import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { DialCodeModel } from '../models/dial-code.model';

export class DialCodesApiService extends ApiService {
  static endpoint = 'dial-codes';

  /**
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<DialCodeModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: DialCodeModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
